import React from 'react';
import loadingLogo from '@src/public/assets/images/loadingLogo.gif';
import styles from './index.css';

const Loading = () => {
    return (
        <div className={styles.wrap}>
            <div className={styles.icon}>
                <img src={loadingLogo} alt="" />
            </div>
        </div>
    );
};

export default Loading;
